export enum DeductibleType {
  TroisCents = '300',
  CentCinquante = '150',
}
